import { useEffect, useState } from 'react';

import { getLTLEquipment } from 'lib/api/getLTLEquipment';
import { Maybe } from 'types/UtilityTypes';

export interface EquipmentOption {
  value: string;
  label: string;
}

export function useLTLEquipment(integrationId: Maybe<number>): {
  options: EquipmentOption[];
  isLoading: boolean;
} {
  const [options, setOptions] = useState<EquipmentOption[]>([]);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    if (integrationId == null) {
      setOptions([]);
      return;
    }
    let cancelled = false;
    setIsLoading(true);

    getLTLEquipment(integrationId, false).then((result) => {
      if (cancelled) {
        return;
      }

      setIsLoading(false);

      if (result.isOk() && result.value.equipment?.length) {
        setOptions(
          result.value.equipment.map((e) => ({
            value: e.value,
            label: e.label,
          }))
        );
      } else {
        setOptions([]);
      }
    });

    return () => {
      cancelled = true;
    };
  }, [integrationId]);

  return { options, isLoading };
}
